import React from "react";

import Button from "@replo/design-system/components/button/Button";
import twMerge from "@replo/design-system/utils/twMerge";
import { ArrowRight } from "lucide-react";

const TOTAL_STEPS = 2;

interface OnboardingFooterProps {
  currentStep: number;
  onNext: (e: React.MouseEvent) => void;
  onBack?: () => void;
  isNextDisabled?: boolean;
  isNextLoading?: boolean;
  nextButtonText?: string;
  className?: string;
}

const OnboardingFooter: React.FC<OnboardingFooterProps> = ({
  currentStep,
  onNext,
  onBack,
  isNextDisabled = false,
  isNextLoading = false,
  nextButtonText = "Continue",
  className,
}) => {
  const showBackButton = currentStep > 1 && onBack;

  return (
    <div className="border-border flex w-full justify-center bg-white px-4 py-4 md:border-t md:px-0 md:py-6">
      <div
        className={twMerge(
          "flex w-full items-center justify-end gap-3 md:justify-between",
          className,
        )}
      >
        <span className="text-muted hidden text-xs md:inline md:text-base">
          Step {currentStep} of {TOTAL_STEPS}
        </span>
        <div className="flex w-full items-center gap-3 md:w-auto md:gap-4">
          {showBackButton && (
            <Button
              variant="secondary"
              size="lg"
              onClick={onBack}
              UNSAFE_className="hidden md:inline-flex"
            >
              Back
            </Button>
          )}
          <Button
            variant="primary"
            onClick={onNext}
            disabled={isNextDisabled}
            isLoading={isNextLoading}
            size="lg"
            UNSAFE_className="w-full md:w-auto"
            endEnhancer={
              isNextLoading ? undefined : <ArrowRight className="h-4 w-4" />
            }
          >
            {isNextLoading ? "Loading..." : nextButtonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingFooter;
